import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";
import history from "./actions/history";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { BrowserRouter as Router } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <div>
    <Router history={history}>
      <App />
    </Router>
  </div>
);
navigator.serviceWorker.register("service-worker.js");

// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
